import { Text } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';
import { messages } from '@databases/intl/messages';
import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';
import styled from 'styled-components';

export type JiraLoadingOperation = 'filtering' | 'sorting';

interface JiraLoadingOverlayProps {
  operation?: JiraLoadingOperation;
}

const OverlayContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  pointer-events: none;
`;

const StickyContent = styled.div`
  position: sticky;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: ${token('space.100')};
  padding: ${token('space.100')} ${token('space.200')};
  background: radial-gradient(
    ellipse 100% 100% at 50% 50%,
    ${token('elevation.surface', '#FFFFFF')} 0%,
    ${token('elevation.surface', '#FFFFFF')}CC 60%,
    ${token('elevation.surface', '#FFFFFF')}00 100%
  );
  border-radius: 3px;
`;

const messageKeyMap: Record<JiraLoadingOperation, keyof typeof messages> = {
  filtering: 'table-layout.filtering-entries',
  sorting: 'table-layout.sorting-entries',
};

export const JiraLoadingOverlay: FunctionComponent<JiraLoadingOverlayProps> = ({
  operation = 'filtering',
}) => {
  const { formatMessage } = useIntl();

  return (
    <OverlayContainer data-testid="jira-loading-overlay">
      <StickyContent>
        <Spinner size="small" />
        <Text color="color.text" size="medium">
          {formatMessage(messages[messageKeyMap[operation]])}
        </Text>
      </StickyContent>
    </OverlayContainer>
  );
};
